var $df68673538e9b991$exports = {};
$df68673538e9b991$exports = {
    "valid": `Valide`
};


export {$df68673538e9b991$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
